export enum CREATE_NEW_ACCOUNT {
  NEW_HOME = 'New home',
  YOUR_DETAILS = 'Your details',
  YOUR_METER = 'Your meter',
  REVIEW = 'Review',
  SUCCESS = 'Success',
}
